/* MŌRA — front page behaviour.
   Safe to re-run: boot() is idempotent and fires again on Shopify
   section reloads so the theme editor stays live. */
(function () {
  function announcement(root) {
    var track = root.querySelector('[data-mo-ann-track]');
    if (!track || track.dataset.moReady) return;
    track.dataset.moReady = '1';
    var msgs = [].slice.call(track.querySelectorAll('.mo-ann__msg')), i = 0, timer;
    if (msgs.length < 2) return;
    function show(n) {
      msgs[i].classList.remove('is-on');
      i = (n + msgs.length) % msgs.length;
      msgs[i].classList.add('is-on');
    }
    function auto() { timer = setInterval(function () { show(i + 1); }, 4500); }
    root.querySelectorAll('[data-ann]').forEach(function (b) {
      b.addEventListener('click', function () {
        clearInterval(timer); show(i + parseInt(b.dataset.ann, 10)); auto();
      });
    });
    auto();
  }

  function video(root) {
    var v = root.querySelector('[data-mo-video]'), t = root.querySelector('[data-mo-video-toggle]');
    if (!v || !t || t.dataset.moReady) return;
    t.dataset.moReady = '1';
    t.addEventListener('click', function () {
      if (v.paused) { v.play(); t.textContent = t.dataset.pause; }
      else { v.pause(); t.textContent = t.dataset.play; }
    });
  }

  function rail(root) {
    var r = root.querySelector('[data-mo-rail]');
    if (!r || r.dataset.moReady) return;
    r.dataset.moReady = '1';
    var p = root.querySelector('[data-mo-rail-prev]'), n = root.querySelector('[data-mo-rail-next]');
    if (!p || !n) return;
    function step() {
      var c = r.querySelector('.mo-card');
      return c ? c.getBoundingClientRect().width + 24 : 280;
    }
    function sync() {
      p.disabled = r.scrollLeft <= 4;
      n.disabled = r.scrollLeft >= r.scrollWidth - r.clientWidth - 4;
    }
    p.addEventListener('click', function () { r.scrollBy({ left: -step(), behavior: 'smooth' }); });
    n.addEventListener('click', function () { r.scrollBy({ left: step(), behavior: 'smooth' }); });
    r.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }

  function trust(root) {
    var g = root.querySelector('[data-mo-trust]');
    if (!g || g.dataset.moReady) return;
    g.dataset.moReady = '1';
    var dots = root.querySelectorAll('[data-mo-trust-dots] i');
    if (!dots.length) return;
    g.addEventListener('scroll', function () {
      var idx = Math.round(g.scrollLeft / (g.scrollWidth / dots.length));
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === idx); });
    }, { passive: true });
  }

  function boot(root) {
    root = root || document;
    announcement(root); video(root); rail(root); trust(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else { boot(); }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
